import {
    GET_RESULTS_MONTHLY_CHART,
    GET_RESULTS_WEEKLY_CHART,
    GET_RESULTS_ANNUAL_CHART,
    GET_RESULTS_HAPPINESS,
    GET_STATE_LOADING,
} from "@/views/chart/store/types/types.js";

const getters = {
    [GET_RESULTS_MONTHLY_CHART]: state => state.resultsMonthlyChart,
    [GET_RESULTS_WEEKLY_CHART]: state => state.resultsWeeklyChart,
    [GET_RESULTS_ANNUAL_CHART]: state => state.resultsAnnualChart,
    [GET_RESULTS_HAPPINESS]: state => state.resultsHappiness,
    [GET_STATE_LOADING]: state => state.loading,
};

export default getters;